import axios from "axios";
export default class RastreioPublicoService {
  tracking(uuid) {
    return axios.get(this.host() + `/api/v1/frete/${uuid}/tracking`);
  }

  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
